import Button from 'components/ReusableComponents/Button'
import useCopyText from 'hooks/useCopyText'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import styles from './GXPLogin.module.scss'
import { useGXPLogin } from './GXPLoginContext'

export default function ReportsCreationStep() {
  const copy = useCopyText()
  const { addToast, removeToast } = useToasts()
  const [loading, setLoading] = useState(false)
  const { data, pushToData } = useGXPLogin()

  const onGetOneTimePasswordClick = async () => {
    if (loading) return
    setLoading(true)
    const toastId = addToast('Getting password...', {
      appearance: 'info',
      autoDismiss: false
    })
    await pmsApi
      .getOneTimePassword({ phone: data.phoneNumber })
      .then(res => {
        copy(res)
      })
      .catch(err => {
        addToast(`${err}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        removeToast(toastId)
        setLoading(false)
      })
  }

  const onClickDone = async () => {
    if (loading) return
    setLoading(true)
    const res = await pmsApi.updateMarriotGxpConfig({ activeStep: 60 })
    pushToData(res)
    setLoading(false)
  }

  return (
    <div>
      <div className={styles.cardTitle}>Create the reports on GXP </div>
      <br />
      <div className={styles.cardText}>
        <div>
          <a
            className={styles.link}
            href="https://marriottintl.my.salesforce.com/"
            target="_blank"
            rel="noreferrer"
          >
            Login to GXP
          </a>{' '}
          using these credentials:
        </div>
        <br />
        <div>{`username: ${data.userName || ''}`}</div>
        <div>{`password: ${data.password || ''}`}</div>
        <br />
        <div>
          When asked,{' '}
          <span className={styles.link} onClick={onGetOneTimePasswordClick}>
            click here
          </span>{' '}
          to get one time password.
        </div>
        <br />
        <div>Then create reports for following Marsha codes:</div>
        <div>{data?.externalHotelIds?.join(', ')}</div>
      </div>
      <div className={styles.actions}>
        <Button onClick={onClickDone} disabled={loading}>
          I’ve created the reports
        </Button>
      </div>
    </div>
  )
}
